module.exports = __webpack_public_path__ + "static/media/56.7f2ba398.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/56.png
// module id = 629
// module chunks = 0